import type { ArticleSummary } from '@rabbit/shared';
import { ArrowDown, Share2, X } from 'lucide-react';
import type { Copy } from '../i18n';

export function PathSheet({ path, current, copy, sharing, onClose, onShare }: { path: ArticleSummary[]; current?: ArticleSummary | undefined; copy: Copy; sharing: boolean; onClose: () => void; onShare: () => void }) {
  return (
    <div className="sheet-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className="path-sheet" role="dialog" aria-modal="true" aria-labelledby="path-title" data-testid="path-sheet">
        <div className="sheet-handle" />
        <header><div><span className="eyebrow">Rabbit</span><h2 id="path-title">{copy.yourPath}</h2></div><button className="icon-button" type="button" aria-label={copy.close} onClick={onClose}><X /></button></header>
        <div className="journey-list">
          {path.length ? path.map((article, index) => (
            <div className="journey-node" key={`${article.id}-${index}`}>
              {article.thumbnailUrl ? <img src={article.thumbnailUrl} alt="" /> : <span className="node-fallback">{article.displayTitle[0]}</span>}
              <strong>{article.displayTitle}</strong>
              {index < path.length - 1 && <ArrowDown className="connector" size={15} />}
            </div>
          )) : <p className="muted">{copy.journeyEmpty}</p>}
        </div>
        {current && <div className="now-viewing"><span>{copy.nowViewing}</span><strong>{current.displayTitle}</strong></div>}
        <button className="primary-button wide" type="button" disabled={!path.length || sharing} onClick={onShare}><Share2 size={18}/>{sharing ? copy.loading : copy.shareJourney}</button>
      </section>
    </div>
  );
}
